<template>
    <page
        :id="state_identifier"
        title="Staff"
        :status="page_status"
        :waiting="waiting"
        @statused="statused"
    >
        <template v-slot:title><span></span></template>

        <data-table
            :id="state_identifier"
            :columns="visible_columns"
            :rows="filtered_rows"
            :search="state.search"
            :total="state.total"
            :found="state.found"
            :current-page="state.page"
            :total-pages="nb_pages"
            :searchable="false"
            table-class="lam-records-list"
            empty-title="No staff members found"
            @sort="sort_by"
            @search="search"
            @page="goto_page"
            @click="record_edit(entity, $event.id)"
            class="uk-margin-top"
        >
            <template v-slot:controls>
                <div class="uk-grid uk-grid-small uk-width-1-1">
                    <div class="uk-width-2-3 lam-list-filters">
                        <ul slot="filters" class="uk-tab" data-uk-tab>
                            <li :class="{'uk-active': current_filter_is('role', $root.constants.roles.ADMIN.id)}">
                                <a href @click.prevent="filter('role', $root.constants.roles.ADMIN.id)">{{ $root.constants.roles.ADMIN.short_name }}</a>
                            </li>
                            <li :class="{'uk-active': current_filter_is('role', $root.constants.roles.BIZ_MANAGER.id)}">
                                <a href @click.prevent="filter('role', $root.constants.roles.BIZ_MANAGER.id)">{{ $root.constants.roles.BIZ_MANAGER.short_name }}</a>
                            </li>
                            <li :class="{'uk-active': current_filter_is('role', $root.constants.roles.PRINCIPAL.id)}">
                                <a href @click.prevent="filter('role', $root.constants.roles.PRINCIPAL.id)">{{ $root.constants.roles.PRINCIPAL.short_name }}</a>
                            </li>
                            <li :class="{'uk-active': current_filter_is('role', $root.constants.roles.ASSOCIATE_PRINCIPAL.id)}">
                                <a href @click.prevent="filter('role', $root.constants.roles.ASSOCIATE_PRINCIPAL.id)">{{ $root.constants.roles.ASSOCIATE_PRINCIPAL.short_name }}</a>
                            </li>
                            <li :class="{'uk-active': current_filter_is('role', $root.constants.roles.SENIOR_ASSOCIATE.id)}">
                                <a href @click.prevent="filter('role', $root.constants.roles.SENIOR_ASSOCIATE.id)">{{ $root.constants.roles.SENIOR_ASSOCIATE.short_name }}</a>
                            </li>
                            <li :class="{'uk-active': current_filter_is('role', $root.constants.roles.ASSOCIATE.id)}">
                                <a href @click.prevent="filter('role', $root.constants.roles.ASSOCIATE.id)">{{ $root.constants.roles.ASSOCIATE.short_name }}</a>
                            </li>
                            <li :class="{'uk-active': current_filter_is('role', $root.constants.roles.SENIOR_LIGHTING_DESIGNER.id)}">
                                <a href @click.prevent="filter('role', $root.constants.roles.SENIOR_LIGHTING_DESIGNER.id)">{{ $root.constants.roles.SENIOR_LIGHTING_DESIGNER.short_name }}</a>
                            </li>
                            <li :class="{'uk-active': current_filter_is('role', $root.constants.roles.LIGHTING_DESIGNER.id)}">
                                <a href @click.prevent="filter('role', $root.constants.roles.LIGHTING_DESIGNER.id)">{{ $root.constants.roles.LIGHTING_DESIGNER.short_name }}</a>
                            </li>
                            <li :class="{'uk-active': current_filter_is('role', $root.constants.roles.DESIGNER.id)}">
                                <a href @click.prevent="filter('role', $root.constants.roles.DESIGNER.id)">{{ $root.constants.roles.DESIGNER.short_name }}</a>
                            </li>
                            <li :class="{'uk-active': current_filter_is('role', 0)}">
                                <a href @click.prevent="filter('role', 0)">All</a>
                            </li>
                        </ul>
                    </div>
                    <div class="uk-width-1-3 uk-text-right">
                        <form-checkbox
                            id="inactive"
                            :value="!!state.archived"
                            name="inactive"
                            @input="toggle_inactive"
                            class="uk-margin-top"
                        >
                            Include Inactive Staff
                        </form-checkbox>
                    </div>
                </div>
            </template>
            <template
                v-slot:summary="{ row }"
            >
                <h6>{{ row.name }} ({{ row.initials }})</h6>
            </template>
            <template
                v-slot:tbody="{ row, field }"
            >
                <router-link
                    v-if="field === 'name'"
                    :to="{ name: 'user.edit', params: { id: row.id } }"
                >
                    {{ row.name }}
                </router-link>
                <a v-else-if="field === 'email'" :href="row.email | nibnut.mailto" @click.stop>{{ row.email }}</a>
                <a v-else-if="field.match(/^main_(phone|mobile)$/)" :href="row[field] | nibnut.telto" @click.stop>{{ row[field] | nibnut.phone }}</a>
                <span v-else-if="field === 'role'">{{ Object.values($root.constants.roles).find(role => role.id === row.role).name }}</span>
                <span v-else>{{ row[field] }}</span>
            </template>
        </data-table>
    </page>
</template>

<script type="text/javascript">
import is_records_list from "../../mixins/IsRecordsListPage"

import FormCheckbox from "../../ui/FormCheckbox"

export default {
    mixins: [is_records_list],
    components: {
        FormCheckbox
    },
    methods: {
        current_filter_is (filter_on, filter) {
            return (this.state.filter_on === filter_on) && (this.state.filter === filter)
        },
        toggle_inactive () {
            this.set_state_values({
                page: 1,
                archived: !this.state.archived
            })
            this.refresh()
        }
    },
    computed: {
        visible_columns () {
            const { proxy, ...visible_columns } = this.columns
            return visible_columns
        }
    },
    data () {
        return {
            entity: "user",
            columns: {
                name: { label: "Name", sort: null, type: "plain", cell_class: "lam-col-name" },
                initials: { label: "Initials", sort: null, type: "plain", cell_class: "lam-col-initials" },
                role: { label: "Role", sort: false, type: "plain" },
                studio_name: { label: "Studio", sort: null, type: "plain", cell_class: "lam-col-initials" },
                email: { label: "Email", sort: false, type: "plain" },
                main_phone: { label: "Office", sort: false, type: "plain" },
                main_mobile: { label: "Mobile", sort: false, type: "plain" },
                proxy: { label: "Proxy", sort: false, type: "plain" }
            },
            default_state: {
                per_page: 30,
                page: 1,
                sort_by: "name",
                sort_dir: "asc",
                filter_on: "role",
                filter: "",
                archived: false,
                search: "",
                total: 0,
                found: 0
            }
        }
    }
}
</script>
